import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import './SubmenuInformatique.css';

const SubMenuDev = () => {
    const navigate = useNavigate();
    const [submenuOpen, setSubmenuOpen] = useState(false);

    return (
        <div 
            className="navlink_with_submenu"
            onMouseEnter={() => setSubmenuOpen(true)}
            onMouseLeave={() => setSubmenuOpen(false)}
        >
            <NavLink
                to="/dev"
                className={({ isActive }) => (isActive ? "active" : "")}
                aria-haspopup="true"
                aria-expanded={submenuOpen}
            >
                Développement Web
            </NavLink>

            <div className={`submenu submenulog ${submenuOpen ? 'open' : ''}`}>
                <div className="navlink_description">
                    <h3>Développement Web</h3>
                    <p>Solutions Webs et déploiements sur des serveurs sécurisés .</p>
                    <button className="submenu_button" onClick={() => { navigate("/dev"); setSubmenuOpen(false); }}>
                        EN SAVOIR PLUS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubMenuDev;
